import { findTarget } from './microcopy.utils'

export const getPartnersTabMicrocopies = (microcopySetValues: any) => {
  return {
    businessPartnersTabText:
      findTarget(`Partners.TAB.1.text`, microcopySetValues, true) || 'Business Partners',
    businessPartnersTabUrl: findTarget(`Partners.TAB.1.url`, microcopySetValues, true),
    publicSectorPartnersTabText:
      findTarget(`Partners.TAB.2.text`, microcopySetValues, true) || 'Technology Partners',
    publicSectorPartnersTabUrl: findTarget(`Partners.TAB.2.url`, microcopySetValues, true),
    technologyPartnersTabText:
      findTarget(`Partners.TAB.3.text`, microcopySetValues, true) || 'Technology Partners',
    technologyPartnersTabUrl: findTarget(`Partners.TAB.3.url`, microcopySetValues, true),
  }
}

export const getBusinessPartnersTiersMicrocopy = (microcopySetValues: any) => {
  return {
    platinumTitleText: findTarget(
      `Partners.business.PLATINUM.title.text`,
      microcopySetValues,
      true
    ),
    platinumBodyText: findTarget(`Partners.business.PLATINUM.body.text`, microcopySetValues, true),
    goldTitleText: findTarget(`Partners.business.GOLD.title.text`, microcopySetValues, true),
    goldBodyText: findTarget(`Partners.business.GOLD.body.text`, microcopySetValues, true),
    authorizedTitleText: findTarget(
      `Partners.business.AUTHORIZED.title.text`,
      microcopySetValues,
      true
    ),
    authorizedBodyText: findTarget(
      `Partners.business.AUTHORIZED.body.text`,
      microcopySetValues,
      true
    ),
    certifiedTitleText: findTarget(
      `Partners.business.CERTIFIED.title.text`,
      microcopySetValues,
      true
    ),
    certifiedBodyText: findTarget(
      `Partners.business.CERTIFIED.body.text`,
      microcopySetValues,
      true
    ),
    awardTitleText: findTarget(`Partners.business.AWARD.title.text`, microcopySetValues, true),
    awardBodyText: findTarget(`Partners.business.AWARD.body.text`, microcopySetValues, true),
  }
}

export const getPublicSectorPartnersTiersMicrocopy = (microcopySetValues: any) => {
  return {
    premierTitleText: findTarget(`Partners.usps.PREMIER.title.text`, microcopySetValues, true),
    premierBodyText: findTarget(`Partners.usps.PREMIER.body.text`, microcopySetValues, true),
    authorizedTitleText: findTarget(
      `Partners.usps.AUTHORIZED.title.text`,
      microcopySetValues,
      true
    ),
    authorizedBodyText: findTarget(`Partners.usps.AUTHORIZED.body.text`, microcopySetValues, true),
    awardTitleText: findTarget(`Partners.usps.AWARD.title.text`, microcopySetValues, true),
    awardBodyText: findTarget(`Partners.usps.AWARD.body.text`, microcopySetValues, true),
  }
}
